import { type UUID } from '~/types/common';

import { useQueryUserGroupsInfinite } from '~/data/userGroup';

import { MultiItemsManager } from './MultiItemsManager';
import { type EntityFilter } from './types';
import { getEntityFilter } from './utils';

type P = {
  readonly filterByEntity?: EntityFilter;
  readonly isCreatingNewEntity?: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly openSelectTestId?: string;
  readonly parentOrganizationalUnitId?: UUID;
  readonly parentUserGroupId?: UUID;
};

export const MultiItemsManagerUserGroups = ({
  isCreatingNewEntity = false,
  filterByEntity,
  isDisabled = false,
  label = 'Benutzergruppen',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  openSelectTestId,
  parentOrganizationalUnitId,
  parentUserGroupId,
}: P) => {
  const filterEntityIn = getEntityFilter(
    'filterContainsEntity',
    filterByEntity,
  );
  const filterEntityNotIn = getEntityFilter(
    'filterNotContainsEntity',
    filterByEntity,
  );

  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQueryUserGroupsInfinite({
      ...filterEntityIn,
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      filterParentUserGroup: parentUserGroupId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQueryUserGroupsInfinite({
      ...filterEntityNotIn,
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      filterNotParentUserGroup: parentUserGroupId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      openSelectTestId={openSelectTestId}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
    />
  );
};
